import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function Careers() {
  return (
    <StaticPage title="Careers at RentalX" subtitle="Help us make student accommodation simple, safe, and affordable across Australia.">
      <Section title="Why Work With Us">
        <p>At RentalX, we're on a mission to solve one of the biggest pain points for students arriving in Australia — finding a safe and affordable place to live. We're a fast-growing proptech startup headquartered in Melbourne, with a passionate team spread across Australia.</p>
        <p>We offer competitive salaries, flexible working, equity options, and the chance to make a real difference in thousands of students' lives every year.</p>
      </Section>

      <Section title="Open Positions">
        <CardGrid items={[
          { title: 'Senior React Developer', desc: 'Full-time · Melbourne or Remote — Build the future of our student-facing platform.' },
          { title: 'Product Manager', desc: 'Full-time · Melbourne — Own the roadmap for our landlord tools and listing experience.' },
          { title: 'Growth Marketing Manager', desc: 'Full-time · Sydney or Remote — Drive student acquisition across Australia and SE Asia.' },
          { title: 'Customer Success Lead', desc: 'Full-time · Melbourne — Help landlords and students get the most from RentalX.' },
          { title: 'Data Analyst', desc: 'Full-time · Remote — Turn our data into insights that shape product and strategy.' },
          { title: 'Operations Coordinator', desc: 'Part-time · Melbourne — Keep the day-to-day running smoothly.' },
        ]} />
      </Section>

      <Section title="Benefits">
        <ul className="list-disc list-inside space-y-2">
          <li>Competitive salary + equity options</li>
          <li>Flexible remote / hybrid working</li>
          <li>Professional development budget (A$2,000/year)</li>
          <li>Monthly team lunches and quarterly off-sites</li>
          <li>Paid parental leave</li>
          <li>Free RentalX Premium membership for you and a friend</li>
        </ul>
      </Section>

      <Section title="How to Apply">
        <p>Send your CV and a short cover letter to <strong>careers@rentalx.com.au</strong>. We respond to every application within 5 business days.</p>
      </Section>
    </StaticPage>
  );
}
